/**
 * Google Analytics 4 + Google Ads conversion helper.
 * - GA4 is loaded lazily only when REACT_APP_GA_MEASUREMENT_ID is set.
 * - Google Ads gtag (AW-18165845430) is loaded directly from public/index.html
 *   with Consent Mode v2 default = denied. The CookieConsentBanner toggles it.
 * - GA4 respects the same consent state via gtag('consent', 'update', ...).
 */
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const ADS_ID = "AW-18165845430";
let injected = false;

function ensureLoaded() {
  if (!GA_ID || injected || typeof window === "undefined") return;
  injected = true;
  // 1) Inject gtag script for GA4 (consent default already set in index.html)
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  // 2) Initialize dataLayer (gtag may already be there because of Ads tag in index.html)
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
  }
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

export function trackPageview(path) {
  ensureLoaded();
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path || window.location.pathname + window.location.search,
    page_location: window.location.href,
  });
}

export function track(eventName, params = {}) {
  ensureLoaded();
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
}

/**
 * Fire a Google Ads conversion (purchase) event.
 * Use `send_to: '<AW-ID>/<LABEL>'` once you have a specific conversion action
 * label from Google Ads. For now we send the generic 'conversion' event
 * tied to the Ads tag — Google Ads PMax will auto-detect purchases via
 * the linked GA4 import too.
 */
export function trackAdsConversion(params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", {
    send_to: ADS_ID,
    currency: "EUR",
    ...params,
  });
}

export const GA_ENABLED = !!GA_ID;
export const ADS_ENABLED = true;
